import { useState, useEffect } from 'react';

import { Card } from '@common/ui/Card';

type ItemValue = string | number;

export interface Item {
  value: ItemValue;
  label: string;
}

export interface CardSelectProps
  extends Omit<
    React.DetailedHTMLProps<
      React.HTMLAttributes<HTMLDivElement>,
      HTMLDivElement
    >,
    'onChange'
  > {
  items: Item[];
  value?: ItemValue;
  onChange?: (item: Item) => void;
}

export const CardSelect = ({
  value,
  items,
  onChange,
  ...props
}: CardSelectProps) => {
  const [selectValue, setSelectValue] = useState<ItemValue>();

  useEffect(() => {
    setSelectValue(value);
  }, [value]);

  const onChangeHandler = (item: Item) => {
    setSelectValue(item.value);
    onChange?.(item);
  };

  return (
    <div
      {...props}
      style={{ display: 'flex', gap: 12 }}
      data-test-id="card-select-container"
    >
      {items.map((item) => (
        <Card
          key={item.value}
          testId={`card-select-option-${item.value}`}
          onClick={() => onChangeHandler(item)}
          selected={selectValue === item.value}
          variant="outlined"
          style={{
            height: 56,
            padding: 0,
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {item.label}
        </Card>
      ))}
    </div>
  );
};
